const ReadingTable = ({csvData}) => {

    
  return (
    <>
      <div className="card">
        <div className="card-header">
          <h4 className="card-title mb-0">Reading Table 1</h4>
        </div>
        <div className="card-body">
          <div
            className="table-responsive"
            style={{ maxHeight: "172px", overflowY: "scroll",  }} // Add scrollbar styles
          >
            {csvData && csvData.length > 0 && (
              <table className="table table-striped mb-0">
                <thead>
                  <tr>
                    {Object.keys(csvData[0]).map((key, idx) => (
                      <th key={idx}>{key}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {csvData.map((row, index) => (
                    <tr key={index}>
                      {Object.values(row).map((val, idx) => (
                        <td key={idx}>{val}</td>
                      ))}
                    </tr>
                  ))}
                  
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
  
     
   }
   export default ReadingTable;